export default __webpack_public_path__ + "static/8-316faa13f365353b50e87ef513dd7033.webp";